import { colors, screen, fonts } from 'components/styles/variables';
import emailIcon from 'public/static/images/vdp/email.svg';
import callIcon from 'public/static/images/vdp/call.svg';
import callIconGray from 'public/static/images/vdp/call-gray.svg';
import shareIcon from 'public/static/images/vdp/share.svg';
import css from 'styled-jsx/css';

export default css`
  .vehicle-snapshot {
    width: 100%;
    color: ${colors.BLACK};
  }

  .title-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 14px;
  }

  .title {
    max-width: 280px;
    font-size: 21px;
    font-weight: 700;
  }

  @media (min-width: ${screen.smMin}) {
    .title {
      font-size: 24px;
      max-width: 420px;
      margin-bottom: 16px;
    }
  }

  .price {
    text-align: right;
    font-size: 21px;
    font-weight: 700;
    margin-bottom: 1px;
  }

  @media (min-width: ${screen.smMin}) {
    .price {
      font-size: 24px;
      margin-bottom: 7px;
    }
  }

  .monthly-payment {
    font-size: 14px;
    font-weight: 400;
  }

  @media (min-width: ${screen.smMin}) {
    .monthly-payment {
      font-size: 18px;
    }
  }

  .secondary-info {
    display: flex;
    border-bottom: 1px solid ${colors.G2};
  }

  .mileage-mobile {
    font-size: 16px;
    font-weight: 400;
    padding: 4px 12px 12px 0px;
  }

  .mileage-desktop {
    display: none;
  }

  @media (min-width: ${screen.smMin}) {
    .mileage-mobile {
      display: none;
    }

    .mileage-desktop {
      display: block;
      font-size: 18px;
      font-weight: 400;
      padding: 4px 18px 12px 0px;
    }
  }

  .location {
    border-left: 1px solid ${colors.G2};
    padding: 4px 0px 12px 12px;
    font-size: 16px;
    font-weight: 400;
  }

  @media (min-width: ${screen.smMin}) {
    .location {
      padding: 4px 0px 12px 18px;
      font-size: 18px;
    }
  }

  .actions {
    grid-auto-flow: column;
    display: grid;
    padding: 20px 12px;
    border-bottom: 1px solid ${colors.G2};
  }

  @media (min-width: ${screen.smMin}) {
    .actions {
      grid-auto-columns: max-content;
      grid-column-gap: 20px;
      padding: 22px 0px 22px 1px;
    }
  }

  .email-container {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
  }

  @media (min-width: ${screen.smMin}) {
    .email-container {
      display: none;
    }
  }

  .email-icon {
    width: 20px;
    height: 16px;
    background-image: url(${emailIcon});
    background-size: cover;
    margin-right: 8px;
  }

  .email {
    color: ${colors.BLACK};
    font-size: 16px;
    font-weight: 600;
  }

  @media (min-width: ${screen.smMin}) {
    .email {
      font-size: 18px;
    }
  }

  .call-icon {
    width: 20px;
    height: 20px;
    background-image: url(${callIcon});
    background-size: cover;
    margin-right: 10px;
  }

  .call {
    color: ${colors.BLACK};
    font-size: 16px;
    font-weight: 600;
  }

  @media (min-width: ${screen.smMin}) {
    .call {
      font-size: 18px;
    }
  }

  .active > .call-icon {
    background-image: url(${callIconGray});
  }

  .active > .call {
    color: ${colors.G3};
  }

  .share-button {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0
    background: none;
    border: none;
    font-family: ${fonts.default};
  }

  .share-icon {
    width: 21px;
    height: 19px;
    background-image: url(${shareIcon});
    background-size: cover;
  }

  @media (min-width: ${screen.smMin}) {
    .share-icon {
      background-image: url(${shareIcon});
      margin-right: 9px;
    }
  }

  .share {
    display: none;
  }

  @media (min-width: ${screen.smMin}) {
    .share {
      color: ${colors.BLACK};
      display: block;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .share-container {
    position: relative;
    display: flex;
    justify-content: flex-end;
  }

  .share-dropdown {
    display: none;
    position: absolute;
    left: -27px;
    top: 27px;
  }

  @media (min-width: ${screen.smMin}) {
    .share-container:hover .share-dropdown {
      display: block;
    }
  }


  .button {
    cursor: pointer;
    font-family: ${fonts.default};
    border: none;
    background-color: transparent;
  }

  .button:focus {
    outline: 0;
  }
`;
